// extracted by mini-css-extract-plugin
export default {"page-title":"PageTitle_page-title__m5+aU"};